import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStatusBarIconStyles = makeStyles(({ palette }) => {
  return createStyles({
    icon: {
      height: 20,
      filter: `${palette.mode === 'dark' ? 'invert(1)' : ''}`,
    },
  });
});

export default useStatusBarIconStyles;
